export const JourneyTabValue = 'journey';
export const GongTabValue = 'gong';
export const GoogleDriveTabValue = 'google-drive';
export const MicrosoftOneDriveTabValue = 'microsoft-one-drive';
export const DropboxTabValue = 'dropbox';
export const BoxTabValue = 'box';

export type IntegrationValue = 'journey' | 'gong' | 'google-drive' | 'microsoft-one-drive' | 'dropbox' | 'box';
export type IntegrationTab = {
  icon: React.ReactNode;
  label: string;
  value: IntegrationValue;
};
